import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Chock } from "../../models/Chock";
import { getChocks } from "../../repositories/ChockRepository";
import { TableChock } from "./components/TableChock";

type useChocksProps = {
	partId?: number;
	onError?: (error: Error) => void;
};

export const useChocks = ({ partId, onError }: useChocksProps) => {
	return useQuery<Chock[], Error>({
		queryKey: ["chocks", partId],
		meta: { realtime: ["M2.GetChocks"] },
		queryFn: ({ signal }) => getChocks({ partId }, signal),
		onError: onError,
	});
};

export const ChockPage = () => {
	const { partId } = useParams();

	return (
		<>
			<HelmetDexteel title="Chocks" />
			<TableChock partId={partId} />
		</>
	);
};
